function importAll(r) {
    return r.keys().map(r);
  }
  
  const Greece_L = importAll(require.context('../assets/photos/Greece_L', false, /\.(png|jpe?g|svg)$/));
    
  export default Greece_L;